import { useEffect, useState } from "react";
import { API_BASE } from "../api/api";

// The VAT rate the server charges, from GET /pricing/vat (backend/app/vat.py).
// It is 0 until Emporia is VAT-registered (owner, 2026-10-20), and cart and
// checkout show a VAT line only when it is above 0, so the page always shows
// the VAT the server will actually add. Turning VAT back on is one setting on
// the API (VAT_RATE); nothing here changes.
//
// Fetched once per page load and shared. Until the answer arrives, and if
// the request fails, the rate is 0: the server, not this figure, decides
// what is charged.
let cached = null;
let inflight = null;

export function loadVatRate() {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = fetch(`${API_BASE}/pricing/vat`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const rate = Number(d?.vat_rate);
        cached = Number.isFinite(rate) && rate > 0 ? rate : 0;
        return cached;
      })
      .catch(() => {
        inflight = null;
        return 0;
      });
  }
  return inflight;
}

export function vatPercentLabel(rate) {
  return `${Math.round(rate * 1000) / 10}`;
}

export function useVatRate() {
  const [rate, setRate] = useState(cached ?? 0);
  useEffect(() => {
    let live = true;
    loadVatRate().then((r) => { if (live) setRate(r); });
    return () => { live = false; };
  }, []);
  return rate;
}

// For tests only.
export function _resetVatRateCache() {
  cached = null;
  inflight = null;
}
